import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const TopCitedDomainsTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>
                        Top cited domains by LLMS while answering to prompts. 
                  </p>
            </BaseTooltip>
      );
};
